// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".description-mandatory-warning{overflow-y:auto}.add-description{border:2px solid #cdcdcd;border-radius:8px}.add-description .v-textarea textarea{font-size:10px;line-height:14px}.add-description .v-input__control>.v-input__slot:after{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
